import styled from '@emotion/styled'
import { mq } from '../../../helpers'
import { gsColors } from '../../../styles/Variables'

export const ServicesContainer = styled.section`
  padding: 60px 88px;
  max-width: 1600px;
  gap: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${mq('max', '1280px')} {
    padding: 60px 44px; 
  }

  ${mq('max', '1024px')} {
    padding: 60px 22px; 
  }

  ${mq('max', '960px')} {
    padding: 60px 22px; 
  }

  .content-wrapper {
    max-width: 1600px;
  }
  
  ${mq('max', '768px')} {
    padding: 20px 30px;
  }

  ${mq('max', '768px')} {
    padding: 20px 16px;
  }
`


export const ServiceSectionContainer = styled.div`
  .service-card-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: space-between;

  }

  .service-section-footer {
    padding: 72px 0;
    
    ${mq('max', '768px')} {
      padding: 38px 0;
    }
    
    .content {
      border-left: 1px solid black;
      padding-left: 104px;

      ${mq('max', '1024px')} {
        padding-left: 52px;
      }

      ${mq('max', '768px')} {
        padding-left: 30px;
      }

    }
    
  }
`

export const ServiceCardContainer = styled.div`
  flex: 1;
  flex-basis: calc(50% - 8px);
  max-width: calc(50% - 8px);
  background-color: ${gsColors.khaki};
  padding: 32px;
  min-height: 288px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 24px;

  h2 {
    ${mq('max', '960px')} {
      font-size: 24px;
    }
  }

  .service-card-footer {
    width: 100%;
    
    .service-card-info {
      display: flex;
      flex-direction: column;
      gap: 4px; 

      ${mq('max', '768px')} {
        flex-direction: row;
        justify-content: space-between;
        flex: 1;
        width: 100%;
        margin-bottom: 20px;

        p {
          font-size: 16px;
        }
      }

      .service-time-container {
        display: flex;
        gap: 8px;
      }
    }
  }

  ${mq('max', '768px')} {
    max-width: 100%;
    flex-basis: 100%;
    flex-direction: column;
    min-height: auto;
  }

  &:hover {
    cursor: pointer;
    .bottom-container {
      .button-container {
        .service-card-book-button {
          border-color: ${gsColors.cobalt};
          
          p {
            color: ${gsColors.cobalt};
          }
        }
      }
    }
  }

  .top-container {
    max-width: 90%;

    p {
      ${mq('max', '960px')} {
        font-size: 18px;
      }

      ${mq('max', '768px')} {
        font-size: 16px;
      }
    }
  }

  .bottom-container {
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: flex-end;

    ${mq('max', '768px')} {
      flex-direction: column;
      align-items: flex-start;
    }

    .button-container {
      display: flex;
      align-items: flex-end;

      .service-card-informational-button {
        text-decoration: none;
        border-bottom: 2px solid black;

        p {
          width: max-content;

          ${mq('max', '768px')} {
            font-size: 16px;
          }
        }
      }

      .service-card-book-button {
        &:hover {
          cursor: pointer;
        }

        white-space: nowrap;
        width: max-content;
        transition: all 0.2s ease;
        background-color: transparent;
        border: 1px solid black;
        color: black;
        padding: 14px 50px;
      }
    }
  }
`
